// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { IconWrapper } from "@insite/mobius/Icon";
import { StyledClickable } from "@insite/mobius/Link";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import useCurrentPageHref from "@werner/App/Hooks/useCurrentPageHref";
import Tooltip, { TooltipPresentationProps } from "@werner/MobiusOverrides/Tooltip/Tooltip";
import React from "react";
import { css } from "styled-components";

interface OwnProps {
    triggerComponent: React.ReactElement<{ tabIndex: number }>;
}

export type Props = OwnProps;

export interface ShareThisButtonStyles {
    wrapper?: InjectableCss;
    tooltipStyles?: TooltipPresentationProps;
}

export const shareThisButtonStyles: ShareThisButtonStyles = {
    tooltipStyles: {
        mergeCss: true,
        cssOverrides: {
            tooltipClickable: css`
                display: inline-block;
                vertical-align: middle;
                & > ${StyledClickable} {
                    display: flex;
                }
                &:focus {
                    outline: none;
                }

                &&& ${IconWrapper} {
                    margin-right: 8px;
                }
            `,
        },
    },
};

const styles = shareThisButtonStyles;

const ShareThis: React.FC<Props> = ({ triggerComponent }) => {
    const pageUrl = useCurrentPageHref();
    const initPlugin = () => {
        if (typeof window === "undefined") {
            return;
        }
        const w = window as any;

        if (w.st) {
            w.st.initialize();
        }
    };

    if (!triggerComponent || !pageUrl) {
        return null;
    }

    const content = <StyledWrapper className="sharethis-inline-share-buttons" data-url={pageUrl}></StyledWrapper>;

    return (
        <Tooltip
            {...styles.tooltipStyles}
            text={content}
            placement="bottom"
            triggerComponent={triggerComponent}
            onTrigger={event => {
                initPlugin();
            }}
        />
    );
};

export default ShareThis;
